"use client";
import React, { useState, useEffect } from "react";
import { AutoComplete } from "antd";
// import headerImage from "../../../assets/images/premeium-marketplace.jpeg";
import headerImage from "../../../assets/images/WhatsApp-01.jpg";
import Check from "../../../assets/images/Hunarmand/hunarmandcheck.png";
import BankAlfalahLogo from "../../../assets/images/Islamic/islamic-logo.png";
import AlfaLogo from "../../../assets/images/Alfalah-whatsapp.png";
import "./WhatsAppForm.scss";

const InstallmentForm = ({ onClose, backgroundColor = "#D41115" }) => {
  const [formData, setFormData] = useState({
    productTitle: "",
    budget: "",
    isBnpl: true,
    cardType: "Bank Alfalah",
    phoneNumber: "",
    city: "",
  });

  const [errors, setErrors] = useState({
    productTitle: "",
    budget: "",
    isBnpl: "",
    cardType: "",
    phoneNumber: "",
    city: "",
  });

  const [touched, setTouched] = useState({
    productTitle: false,
    budget: false,
    isBnpl: false,
    cardType: false,
    phoneNumber: false,
    city: false,
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [apiResponse, setApiResponse] = useState("");

  const [cities, setCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    fetchCities("1089");
  }, []);

  const fetchCities = async (provinceId) => {
    try {
      setIsLoading(true);
      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BACKEND}/order/cities${
          provinceId ? `?state_id=${provinceId}` : ""
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch cities");
      }

      const data = await response.json();
      setCities(data || []);
    } catch (error) {
      console.error("Error fetching cities:", error);
      setErrors((prev) => ({
        ...prev,
        city: "Failed to load cities",
      }));
    } finally {
      setIsLoading(false);
    }
  };

  const handleCitySelect = (value, option) => {
    setSelectedCity(value);
    setFormData({
      ...formData,
      city: value,
    });
    setErrors((prev) => ({ ...prev, city: "" }));
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors };

    if (!formData.budget.trim()) {
      newErrors.budget = "Budget is required";
      valid = false;
    } else if (!/^\d+$/.test(formData.budget)) {
      newErrors.budget = "Budget must contain only numbers";
      valid = false;
    } else {
      newErrors.budget = "";
    }

    if (!formData.phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required";
      valid = false;
    } else if (!formData.phoneNumber.startsWith("03")) {
      newErrors.phoneNumber = "Phone number must start with 03";
      valid = false;
    } else if (!/^03\d{9}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Please enter a valid phone number (11 digits)";
      valid = false;
    } else {
      newErrors.phoneNumber = "";
    }

    if (!formData.city) {
      newErrors.city = "Please select a city";
      valid = false;
    } else {
      newErrors.city = "";
    }

    setErrors(newErrors);
    return valid;
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (name === "phoneNumber") {
      const numericValue = value.replace(/[^0-9]/g, "");
      if (numericValue.length <= 11) {
        setFormData({
          ...formData,
          [name]: numericValue,
        });
      }
    } else if (name === "budget") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setFormData({
        ...formData,
        [name]: numericValue,
      });
    } else if (type === "radio") {
      setFormData({
        ...formData,
        [name]: name === "isBnpl" ? value === "true" : value,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    setTouched({
      ...touched,
      [name]: true,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const allTouched = Object.keys(touched).reduce((acc, key) => {
      acc[key] = true;
      return acc;
    }, {});
    setTouched(allTouched);

    if (validateForm()) {
      setIsSubmitting(true);
      setSubmitStatus(null);
      setApiResponse("");

      try {
        const response = await fetch(
          `${process.env.NEXT_PUBLIC_BACKEND}/ginkgo_integration/whatsapp_lead_generation`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              budget: parseInt(formData.budget),
              is_bnpl: formData.isBnpl,
              card_type: formData.cardType,
              phone_number: formData.phoneNumber,
              city: formData.city,
              product_title: formData.productTitle,
            }),
          }
        );

        if (response.ok) {
          const data = await response.json();
setSubmitStatus("success");
          setApiResponse(data.detail || "Form Submitted Successfully");
          setTimeout(() => {
            onClose();
          }, 5000);
        } else {
          console.error("API error:", response.status);
          setSubmitStatus("error");
        }
      } catch (error) {
        console.error("Request failed:", error);
        setSubmitStatus("error");
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  const handleNumericKeyDown = (e) => {
    if (
      [8, 46, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
      (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
      (e.keyCode === 67 && (e.ctrlKey === true || e.metaKey === true)) ||
      (e.keyCode === 88 && (e.ctrlKey === true || e.metaKey === true)) ||
      (e.keyCode === 86 && (e.ctrlKey === true || e.metaKey === true)) ||
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      return;
    }

    if (
      (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
      (e.keyCode < 96 || e.keyCode > 105)
    ) {
      e.preventDefault();
    }
  };

  const renderContent = () => {
    if (submitStatus === "success") {
      return (
        <div className="whatsapp-form__success-container">
          <div className="whatsapp-form__success-check">
            <img src={Check?.src} alt="Success Check" />
          </div>
          <p className="whatsapp-form__success-message">{apiResponse}</p>
        </div>
      );
    }

    return (
      <form onSubmit={handleSubmit} className="whatsapp-form__content">
        <div className="whatsapp-form__field">
          <label htmlFor="productTitle">Product Name</label>
          <input
            type="text"
            id="productTitle"
            name="productTitle"
            value={formData.productTitle}
            onChange={handleChange}
            placeholder="Enter product name (optional)"
          />
        </div>

        <div className="whatsapp-form__field">
          <label htmlFor="budget">
            Budget (PKR) <span className="required">*</span>
          </label>
          <input
            type="text"
            id="budget"
            name="budget"
            value={formData.budget}
            onChange={handleChange}
            onKeyDown={handleNumericKeyDown}
            placeholder="Enter your budget (PKR)"
            inputMode="numeric"
          />
          {errors.budget && touched.budget && (
            <p className="whatsapp-form__error">{errors.budget}</p>
          )}
        </div>

        <div className="whatsapp-form__field">
          <label>
            Installment <span className="required">*</span>
          </label>
          <div className="radio-group">
            <label className="radio-label">
              <input
                type="radio"
                name="isBnpl"
                value="true"
                checked={formData.isBnpl === true}
                onChange={handleChange}
              />
              <span>Yes</span>
            </label>
            <label className="radio-label">
              <input
                type="radio"
                name="isBnpl"
                value="false"
                checked={formData.isBnpl === false}
                onChange={handleChange}
              />
              <span>No</span>
            </label>
          </div>
        </div>

        <div className="whatsapp-form__field">
          <label>
            Credit Card <span className="required">*</span>
          </label>
          <div className="card-options">
            <label className="card-option">
              <input
                type="radio"
                name="cardType"
                value="Bank Alfalah"
                checked={formData.cardType === "Bank Alfalah"}
                onChange={handleChange}
              />
              <div className="card-option-content">
                <img src={AlfaLogo?.src} alt="Bank Alfalah" />
                <span>Bank Alfalah</span>
              </div>
            </label>
            <label className="card-option">
              <input
                type="radio"
                name="cardType"
                value="Other Bank"
                checked={formData.cardType === "Other Bank"}
                onChange={handleChange}
              />
              <div className="card-option-content">
                <img src={BankAlfalahLogo?.src} alt="Other Bank" />
                <span>Other Bank</span>
              </div>
            </label>
          </div>
        </div>

        <div className="whatsapp-form__field">
          <label htmlFor="phoneNumber">
            Phone Number <span className="required">*</span>
          </label>
          <input
            type="text"
            id="phoneNumber"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            onKeyDown={handleNumericKeyDown}
            placeholder="03XXXXXXXXX"
            maxLength={11}
            inputMode="numeric"
          />
          {errors.phoneNumber && touched.phoneNumber && (
            <p className="whatsapp-form__error">{errors.phoneNumber}</p>
          )}
        </div>

        <div className="whatsapp-form__field">
          <label htmlFor="city">
            City <span className="required">*</span>
          </label>
          <AutoComplete
            className={`lead-generation-autocomplete ${
              errors.city && touched.city
                ? "lead-generation-autocomplete--error"
                : ""
            }`}
            options={cities.map((city) => ({
              value: city.name,
              label: city.name,
              key: city.id,
            }))}
            placeholder="Select City"
            value={selectedCity}
            onChange={(value) => {
              setSelectedCity(value);
              setFormData({
                ...formData,
                city: value,
              });
            }}
            onSelect={handleCitySelect}
            onBlur={() => {
              setTouched((prev) => ({ ...prev, city: true }));
              if (!selectedCity) {
                setErrors((prev) => ({
                  ...prev,
                  city: "Please select a city",
                }));
              }
            }}
            filterOption={(inputValue, option) =>
              option.value.toLowerCase().indexOf(inputValue.toLowerCase()) !==
              -1
            }
            allowClear={true}
            showSearch={true}
            popupClassName="lead-generation-autocomplete-dropdown"
            notFoundContent={isLoading ? "Loading..." : "No city found"}
            getPopupContainer={(trigger) => trigger.parentNode}
          />
          <input type="hidden" name="city" value={formData.city} />
          {errors.city && touched.city && (
            <p className="whatsapp-form__error whatsapp-form__city-error">
              {errors.city}
            </p>
          )}
        </div>

        <button
          type="submit"
          className="whatsapp-form__submit-btn"
          disabled={isSubmitting}
        >
          {isSubmitting ? "Submitting..." : "Submit"}
        </button>

        {submitStatus === "error" && (
          <p className="whatsapp-form__status whatsapp-form__status--error">
            Something went wrong. Please try again.
          </p>
        )}
      </form>
    );
  };

  return (
    <div
      className="whatsapp-form"
      style={{ "--background-color": backgroundColor }}
    >
      <div className="whatsapp-form__banner">
        <img src={headerImage?.src} alt="Installment Plan Banner" />
        <button
          className="whatsapp-form__close-btn"
          onClick={onClose}
          aria-label="Close form"
        >
          &times;
        </button>
      </div>

      <div className="whatsapp-form__card">{renderContent()}</div>
    </div>
  );
};

export default InstallmentForm;
